module.exports = __webpack_public_path__ + "img/img (58).8e4f0ade.jpg";